module.exports = __webpack_public_path__ + "img/add-to-talentpool-blue.ea801dd8.svg";